
import React, { useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { servicesData } from "../pages/servicesData"; // adjust path if needed
import { Helmet } from "react-helmet-async";

export default function ServiceDetails() {
  const [openFaq, setOpenFaq] = React.useState(null);

  const { id } = useParams();
  const navigate = useNavigate();
  const service = servicesData.find((s) => s.id === id);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (service && service.meta && service.meta.pageTitle) {
      document.title = service.meta.pageTitle;
    }
  }, [id, service]);

  if (!service) {
    return (
      <div className="container" style={{ padding: 60 }}>
        <h2>Service not found</h2>
        <Link to="/services" className="btn-default">Back to Services</Link>
      </div>
    );
  }

  const handleBook = (e) => {
    e && e.preventDefault();
    window.preselectedService = service.title;
    if (typeof window.openPopup === "function") {
      window.openPopup();
      return;
    }
    if (service.cta && service.cta.link) {
      if (service.cta.link.startsWith("/")) navigate(service.cta.link);
      else window.location.href = service.cta.link;
      return;
    }
    if (service.cta && service.cta.phone) {
      window.location.href = `tel:${service.cta.phone}`;
      return;
    }
    navigate("/contact");
  };

  // split the features into two columns for the two-column list (fallback if not present)
  const features = service.features || [];
  const mid = Math.ceil(features.length / 2);
  const leftFeatures = features.slice(0, mid);
  const rightFeatures = features.slice(mid);

  // bottom gallery: if service.gallery available use it; otherwise use the main image twice as fallback
  const gallery = service.gallery && service.gallery.length >= 2
    ? service.gallery
    : [service.img, service.img];


  return (
    <>
    <Helmet>
  <title>{service.meta.pageTitle}</title>
  <meta name="description" content={service.meta.metaDescription} />
</Helmet>
    <div className="page-header">
  <div className="container">
    <div className="row">
      <div className="col-lg-12">

        <div className="page-header-box">
          <h1 
            className="text-anime-style-2" 
            data-cursor="-opaque"
          >
            {service.title}
          </h1>

          <nav className="wow fadeInUp">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/services">services</Link>
              </li>
              <li 
                className="breadcrumb-item active" 
                aria-current="page"
              >
                {service.title.toLowerCase()}
              </li>
            </ol>
          </nav>
        </div>

      </div>
    </div>
  </div>
</div>
    <div className="page-service-single">
        
      <div className="container">
        <div className="row">
          {/* Left content (8 cols) */}
          <div className="col-lg-8">
            <div className="service-single-content">
              {/* Featured Image */}
              <div className="service-featured-img">
                <figure className="image-anime">
                  <img loading="lazy" src={service.img} alt={service.title} style={{ width: "100%", borderRadius: 12 }} />
                </figure>
              </div>

              {/* Service Entry */}
              <div className="service-entry">
                {/* Section heading - using a friendly title */}
                <h3 className="wow fadeInUp">Trained Therapists</h3>

                {/* Main paragraphs */}
                {service.content && (
                  <p className="wow fadeInUp" data-wow-delay="0.2s">{service.content}</p>
                )}
                {service.content2 && (
                  <p className="wow fadeInUp" data-wow-delay="0.4s">{service.content2}</p>
                )}

                {/* Why section */}
                {service.content3 && (
                  <>
                    <h3 className="wow fadeInUp" data-wow-delay="0.6s">Why Corrective Exercise</h3>
                    <p className="wow fadeInUp" data-wow-delay="0.8s">{service.content3}</p>
                  </>
                )}

                {/* Two-column bullet list — uses features (fallback to excerpt if no features) */}

             {/* Conditions & Treatments – Side by Side Boxes */}
{(service.conditions?.length > 0 || service.treatments?.length > 0) && (
 <div className="service-box-wrapper">

  {/* Conditions */}
  <div className="service-info-box">
    <h3>Conditions We Treat</h3>
    <ul>
      {service.conditions.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  </div>

  {/* Treatments */}
  <div className="service-info-box">
    <h3>Treatment Methods</h3>
    <ul>
      {service.treatments.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  </div>

</div>

)}

{/* FAQ Section */}
{service.faq?.length > 0 && (
  <div className="service-faq wow fadeInUp" data-wow-delay="1.6s">
    <h3>Frequently Asked Questions</h3>

    <div className="faq-list">
      {service.faq.map((item, idx) => {
        const isOpen = openFaq === idx;

        return (
          <div
            key={idx}
            className={`faq-item ${isOpen ? "open" : ""}`}
            onClick={() => setOpenFaq(isOpen ? null : idx)}
          >
            <div className="faq-question">
              <span>{item.q}</span>
              <span className="faq-icon">
                {isOpen ? "−" : "+"}
              </span>
            </div>

            {isOpen && (
              <div className="faq-answer">
                <p>{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  </div>
)}


           

              </div>
              {/* End service-entry */}
            </div>
            {/* End service-single-content */}
          </div>

          {/* Right sidebar (4 cols) */}
          <div className="col-lg-4">
            <div className="service-sidebar">
              {/* Service categories list */}
              <div className="service-catagery-list wow fadeInUp">
                <h3>our services</h3>
                <ul>
                  {servicesData.map((s) => (
                    <li key={s.id}>
                      <Link to={`/services/${s.id}`} className={s.id === service.id ? "active" : ""}>
                        {s.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Opening hours */}
              <div className="opening-hour-section wow fadeInUp" data-wow-delay="0.25s">
                <h3>opening hours</h3>
                <ul>
                  <li>mon to fri : 10:00 to 6:00</li>
                  <li>sat : 10:00AM To 3:00PM</li>
                  <li>sun : closed</li>
                </ul>
              </div>

              {/* Sidebar CTA */}
              <div className="sidebar-cta-box wow fadeInUp" data-wow-delay="0.5s">
                <div className="icon-box">
                  {/* keep existing icon if you have one in assets, else skip */}
                  {/* <img loading="lazy" src="images/icon-cta.svg" alt="" /> */}
                  <div style={{ width: 48, height: 48, borderRadius: 10, background: "#e6f2ff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    📞
                  </div>
                </div>

                <div className="cta-content">
                  <h3>{service.cta && service.cta.headline ? service.cta.headline : "Ready to Start Your Journey to Recovery?"}</h3>
                  <p>{service.cta && service.cta.text ? service.cta.text : "Contact us today to schedule your initial consultation and take the first step towards a pain-free life."}</p>
                </div>

                <div className="cta-appointment-btn" style={{ marginTop: 12 }}>
                  <a href="https://wa.me/919000666889?text=Hi%20BrightLife%20Physio%20Point,%20I%20would%20like%20to%20book%20an%20appointment." target="_blank"
                    rel="noopener noreferrer" className="btn-default">
                    {service.cta && service.cta.buttonText ? service.cta.buttonText : "book appointment"}
                  </a>
                </div>
              </div>
 
            </div>
            {/* End sidebar */}
          </div>

        </div>
      </div>
    </div>
    </>
  );
}

